import React from 'react';
import Button from '@mui/material/Button';

const PublishButton = (props) => {
  const { name, onClick, disabled, style } = props;
  const actions = onClick ? { onClick } : {};
  return (
    <Button
      variant="contained"
      color="primary"
      type="submit"
      disabled={disabled}
      style={{ color: 'white', ...style }}
      {...actions}
    >
      {name}
    </Button>
  )
}

export default PublishButton;
